import Vue from 'vue';
import Router from 'vue-router';
import { scrollBehavior } from '@bit/duncank.work.utils.router-helpers';
import i18n from './i18n';
import Home from './views/Home.vue';

Vue.use(Router);

const propvalidator_ids = (route) => {
    const props = { ...route.params };
    if (props.id) {
        props.id = +props.id;
    }
    return props;
};

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            alias: ['/nl', '/en'],
            name: 'home',
            component: Home,
            meta: {
                guest: true,
            },
        },
        {
            path: '/overons',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
            meta: {
                guest: true,
                meta: {
                    title: () => i18n.t('menu.about'),
                },
            },
        },
        {
            path: '/vacatures',
            name: 'jobs',
            component: () => import(/* webpackChunkName: "jobs" */ './views/Jobs.vue'),
            meta: {
                guest: true,
                meta: {
                    title: () => i18n.t('menu.jobs'),
                },
            },
        },
        {
            path: '/producten',
            redirect: '/producten/products',
        },
        {
            path: '/producten/:mode',
            name: 'products',
            component: () => import(/* webpackChunkName: "products" */ './views/Products.vue'),
            props(route) {
                return propvalidator_ids(route);
            },
            meta: {
                guest: true,
                meta: {
                    title: () => i18n.t('menu.products'),
                },
            },
            children: [
                {
                    path: ':id',
                    name: 'product',
                    component: () => import(/* webpackChunkName: "products" */ './views/products/ProductInfo.vue'),
                    props(route) {
                        return propvalidator_ids(route);
                    },
                    meta: {
                        guest: true,
                        scrollTop: false,
                        meta: false,
                    },
                },
            ],
        },
        {
            path: '/checkout',
            name: 'checkout',
            component: () => import(/* webpackChunkName: "contact" */ './views/Checkout.vue'),
            meta: {
                guest: true,
            },
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
            meta: {
                guest: true,
                meta: {
                    title: () => i18n.t('menu.contact'),
                },
            },
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue'),
            meta: {
                guest: true,
                meta: {
                    title: () => i18n.t('menu.privacy'),
                },
            },
        },
        {
            path: '/404',
            name: '404',
            component: () => import(/* webpackChunkName: "404" */ './views/404.vue'),
            meta: {
                guest: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            alias: '/logout',
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
            meta: {
                guest: true,
            },
        },
    ],
    scrollBehavior,
});

router.beforeEach(async (to, from, next) => {
    if (store.state.app.nav_opened) {
        store.commit('nav', { action: 'close' });
    }
    if (!to.matched.length) {
        next({ path: '/404', params: { error: to.path } });
    } else if (!to.matched.every((page) => page.meta.guest)) { // Page requires auth
        if (store.getters['Auth/isAuthenticated']) {
            store.commit({
                type: 'setMeta',
                from: 'router',
                data: to,
            });
            next();
        } else {
            store.dispatch('Auth/startSession').then(() => {
                store.commit({
                    type: 'setMeta',
                    from: 'router',
                    data: to,
                });
                next();
            }).catch(() => {
                next({ path: '/login', query: { redirect: to.path } });
            });
        }
    } else {
        // meta(to);
        store.commit({
            type: 'setMeta',
            from: 'router',
            data: to,
        });
        next();
        if (!to.path.startsWith('/logout')) {
            store.dispatch('Auth/startSession').catch(() => { });
        }
    }
});

router.onError((e) => {
    router.replace({ path: '/404', params: { error: e } });
});

export default router;
